import { SubscriptionsCheckup } from '@core/models/interfaces/storage-data/subscriptions-checkup';
import { createActionGroup, props } from '@ngrx/store';

export const SubscriptionsCheckupActions = createActionGroup({
  source: 'SubscriptionsCheckup',
  events: {
    'Load Subscriptions Checkup Success': props<{
      subscriptionsCheckup: SubscriptionsCheckup;
    }>(),
  },
});
